import { Draft } from '@reduxjs/toolkit';

/**
 * Casts a (typically deeply-readonly) validated value into an Immer `Draft`,
 * so it can be assigned into reducer state. Immer types reducer state as a
 * writable `Draft`, so a `readonly` value isn't directly assignable. This is
 * exactly what immer's `castDraft` does, defined here on RTK's re-exported
 * `Draft` type so we don't depend on `immer` directly. Runtime no-op.
 */
export const toDraft = <T>(value: T): Draft<T> => value as Draft<T>;
